import { observer } from 'mobx-react';
import { autoinject, inject, Tooltip } from 'Mri.Web.Common';
import * as React from 'react';
import { BsCheck } from '@react-icons/all-files/bs/BsCheck';
import { BsDashSquareFill } from '@react-icons/all-files/bs/BsDashSquareFill';
import { BsFiles } from '@react-icons/all-files/bs/BsFiles';
import { BsListUl } from '@react-icons/all-files/bs/BsListUl';
import { BsPencilSquare } from '@react-icons/all-files/bs/BsPencilSquare';
import { BsPlusSquareFill } from '@react-icons/all-files/bs/BsPlusSquareFill';
import { LinkContainer } from 'react-router-bootstrap';
import { Button, ButtonGroup } from 'reactstrap';
import { PartDefinitionGroup } from './PartDefinitionsList';
import { PartDefinitionsStore } from './PartDefinitionsStore';

export interface IPartDefinitionItemProps {
    readonly part: PartDefinitionGroup;
}

@autoinject
@observer
export class PartDefinitionItem extends React.Component<IPartDefinitionItemProps> {
    public render() {
        const partGroup = this.props.part;

        return (
            <>
                <tr className="">
                    <td style={{ width: '20px' }}>
                        {partGroup.count > 1 && (
                            <a onClick={partGroup.toggle} className={`list-group-item-text`}>
                                <em>{partGroup.open ? <BsDashSquareFill /> : <BsPlusSquareFill />}</em>
                            </a>
                        )}
                    </td>
                    <td className="align-middle">{partGroup.head.partNumber}</td>
                    <td className="align-middle">{partGroup.count == 1 && partGroup.topPartDef.revision}</td>
                    <td className="align-middle">{partGroup.head.description}</td>
                    <td className="align-middle">{partGroup.count == 1 && partGroup.head.comments}</td>
                    <td className="align-middle">
                        {partGroup.count == 1 && partGroup.topPartDef.isTopLevel && <BsCheck />}
                    </td>
                    <td className="align-middle">{partGroup.count == 1 && partGroup.topPartDef.partCount}</td>

                    <td className="align-middle">
                        <ButtonGroup className="py-1">
                            <Tooltip message="Edit Part" delay={0}>
                                <LinkContainer to={`/part-definitions/${partGroup.head.partNumber}/edit`}>
                                    <Button color="primary">
                                        <BsPencilSquare />
                                    </Button>
                                </LinkContainer>
                            </Tooltip>

                            <Tooltip message="New Revision" delay={0}>
                                <LinkContainer
                                    to={{
                                        pathname: `/part-definitions/${partGroup.head.partNumber}/revision/create`,
                                        state: { copy: partGroup.head.partNumber },
                                    }}
                                >
                                    <Button color="primary">
                                        <BsFiles />
                                    </Button>
                                </LinkContainer>
                            </Tooltip>

                            {partGroup.count == 1 && (
                                <Tooltip message="Parts" delay={0}>
                                    <LinkContainer to={`/parts/${partGroup.topPartDef.partDefinitionGuid}`}>
                                        <Button color="primary">
                                            <BsListUl className="" />
                                        </Button>
                                    </LinkContainer>
                                </Tooltip>
                            )}
                        </ButtonGroup>
                    </td>
                </tr>
                {partGroup.open &&
                    partGroup.count > 1 &&
                    partGroup.head.partDefinitions?.map(p => (
                        <tr className="" key={p.partNumber + p.revision}>
                            <td />
                            <td className="align-middle">--</td>
                            <td className="align-middle">{p.revision}</td>
                            <td className="align-middle" />
                            <td className="align-middle">{p.comments}</td>
                            <td className="align-middle">{p.isTopLevel && <BsCheck />}</td>
                            <td className="align-middle">{p.partCount}</td>
                            <td className="align-middle">
                                <ButtonGroup className="py-1">
                                    {p.partCount > 0 && (
                                        <Tooltip message="Parts" delay={0}>
                                            <LinkContainer to={`/parts/${p.partDefinitionGuid}`}>
                                                <Button color="primary">
                                                    <BsListUl className="" />
                                                </Button>
                                            </LinkContainer>
                                        </Tooltip>
                                    )}
                                </ButtonGroup>
                            </td>
                        </tr>
                    ))}
            </>
        );
    }

    @inject
    private readonly partDefsStore!: PartDefinitionsStore;
}
